module.exports = __webpack_public_path__ + "static/media/exide-silver-calcium.5d08f520.svg";